import { render, staticRenderFns } from "./transfergoods.vue?vue&type=template&id=c223c354&scoped=true&"
import script from "./transfergoods.vue?vue&type=script&lang=js&"
export * from "./transfergoods.vue?vue&type=script&lang=js&"
import style0 from "./transfergoods.vue?vue&type=style&index=0&id=c223c354&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c223c354",
  null
  
)

export default component.exports